module.exports = require('./lib/react.js')



//////////////////
// WEBPACK FOOTER
// ./~/glamor/react.js
// module id = 16
// module chunks = 35783957827783 162898551421021 231608221292675